// extracted by mini-css-extract-plugin
module.exports = {"summaryError":"CalculatorResult_summaryError__FuzPY","summaryText":"CalculatorResult_summaryText__U3XoF"};